<template>
  <el-dialog :visible="visible" title="铺货检测" width="680px" top="6vh" append-to-body custom-class="doudian-distribution-check" :close-on-click-modal="false" @close="onClose">
    <div class="ddc-shop">{{ shop && shop.shop_name }}</div>
    <el-alert v-if="error" :title="error" type="error" :closable="false" show-icon />
    <div v-if="loading" class="ddc-loading" role="status"><i class="el-icon-loading" /> 正在核验应用授权及平台权益，请稍候……</div>
    <template v-else-if="result">
      <div class="ddc-overview">
        <div>铺货模式：<strong>{{ modeText }}</strong></div>
        <div>检测结论：<strong :class="'ddc-text--' + readinessTone">{{ readinessText }}</strong></div>
        <span class="ddc-time">检测时间：{{ formatTime(result.checked_at) }}</span>
      </div>
      <div class="ddc-primary" :class="'ddc-primary--' + primary.status" data-application="primary">
        <div class="ddc-primary-title"><i :class="statusIcon(primary.status)" aria-hidden="true" /><strong>主商品应用{{ statusText(primary.status) }}</strong></div>
        <div class="ddc-name">{{ primary.app_name || '默认商品应用' }}<span v-if="primary.service_id">（{{ primary.service_id }}）</span></div>
        <p>{{ primary.reason || '本次未能确认主应用状态，请重试' }}</p>
        <div class="ddc-expiry">服务到期：{{ formatTime(primary.app_expire_time) }}</div>
        <strong v-if="primary.status !== 'normal'" class="ddc-primary-required">主应用必须正常，第二应用不能独立铺货。</strong>
        <el-button v-if="primary.status !== 'normal'" size="small" @click="$emit('primary-authorization')">处理主应用</el-button>
      </div>
      <div v-if="secondary" class="ddc-secondary" data-application="secondary">
        <div class="ddc-secondary-title"><strong>第二商品应用：{{ secondary.app_name || secondary.service_id }}</strong><span :class="'ddc-text--' + secondary.status">{{ statusText(secondary.status) }}</span></div>
        <p>{{ secondary.reason || '本次未能确认第二应用状态' }}</p>
        <div class="ddc-expiry">服务到期：{{ formatTime(secondary.app_expire_time) }}</div>
      </div>
      <p v-if="result.distribution_block_reason" class="ddc-block-reason">{{ result.distribution_block_reason }}</p>
      <p v-if="refreshWarning" class="ddc-refresh-warning">{{ refreshWarning }}</p>
    </template>
    <p class="ddc-note">仅核验应用授权和准入条件，不提交商品。额度、算力和素材仍由原铺货流程校验。</p>
    <template #footer>
      <el-button v-if="result && !loading" size="small" @click="$emit('manage-applications')">管理第二应用</el-button>
      <el-button type="primary" size="small" :loading="loading" :disabled="loading" @click="$emit('retry')">{{ loading ? '检测中' : '重新检测' }}</el-button>
      <el-button size="small" @click="$emit('close')">关闭</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'DoudianDistributionCheckDialog',
  props: {
    visible: Boolean,
    loading: Boolean,
    shop: { type: Object, default: null },
    result: { type: Object, default: null },
    error: { type: String, default: '' },
    refreshWarning: { type: String, default: '' }
  },
  computed: {
    primary() { return this.result && this.result.primary_application || { status: 'unknown' } },
    secondary() { return this.result && this.result.secondary_application || null },
    modeText() { return { primary: '主应用铺货', dual: '双应用铺货', unselected: '待指定铺货应用', unknown: '模式待确认' }[this.result.distribution_mode] || '模式待确认' },
    readinessText() { return this.result.application_ready === true ? '应用授权已就绪' : this.result.application_ready === false ? '应用授权未就绪' : '本次未能确认应用状态' },
    readinessTone() { return this.result.application_ready === true ? 'normal' : this.result.application_ready === false ? 'abnormal' : 'unknown' }
  },
  methods: {
    onClose() { if (this.visible) this.$emit('close') },
    statusText(status) { return { normal: '正常', abnormal: '异常', unknown: '待确认' }[status] || '待确认' },
    statusIcon(status) { return { normal: 'el-icon-success', abnormal: 'el-icon-error', unknown: 'el-icon-question' }[status] || 'el-icon-question' },
    formatTime(value) {
      if (!Number.isFinite(value) || value <= 0) return '待确认'
      const date = new Date(value * 1000)
      if (Number.isNaN(date.getTime())) return '待确认'
      const pad = item => String(item).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
    }
  }
}
</script>

<style>
.doudian-distribution-check.el-dialog { max-width: calc(100vw - 24px); max-height: 88vh; display: flex; flex-direction: column; border-radius: 10px; }
.doudian-distribution-check .el-dialog__body { padding: 12px 22px 18px; overflow-y: auto; }
.doudian-distribution-check .el-dialog__header, .doudian-distribution-check .el-dialog__footer { flex-shrink: 0; }
.ddc-shop { color: #303744; font-weight: 600; font-size: 14px; margin-bottom: 14px; overflow-wrap: anywhere; }
.ddc-loading { padding: 28px 0; font-size: 13px; color: #747d8c; line-height: 1.8; }
.ddc-overview { font-size: 13px; line-height: 1.9; margin-bottom: 16px; color: #5c6574; }
.ddc-time, .ddc-expiry { font-size: 12px; color: #7f8895; }
.ddc-primary { padding: 16px; border: 1px solid #d9dee6; border-left-width: 4px; border-radius: 7px; background: #f7f8fa; }
.ddc-primary--normal { border-color: #a5cbb0; background: #f5faf6; }
.ddc-primary--abnormal { border-color: #e1a29c; background: #fff6f5; }
.ddc-primary-title { display: flex; align-items: center; gap: 8px; font-size: 17px; }
.ddc-primary--normal .ddc-primary-title, .ddc-text--normal { color: #37804b; }
.ddc-primary--abnormal .ddc-primary-title, .ddc-text--abnormal { color: #bd4b43; }
.ddc-primary--unknown .ddc-primary-title, .ddc-text--unknown { color: #7f8895; }
.ddc-name { margin-top: 12px; color: #454f5f; font-weight: 600; font-size: 13px; overflow-wrap: anywhere; }
.ddc-name span { font-weight: 400; color: #7f8895; }
.ddc-primary p, .ddc-secondary p { font-size: 13px; line-height: 1.7; margin: 8px 0; overflow-wrap: anywhere; }
.ddc-primary-required { display: block; font-size: 12px; line-height: 1.7; margin: 12px 0; color: #6b5960; }
.ddc-secondary { padding: 14px 0; margin-top: 8px; border-bottom: 1px solid #eceef2; }
.ddc-secondary-title { display: flex; align-items: center; flex-wrap: wrap; gap: 8px 16px; font-size: 13px; overflow-wrap: anywhere; }
.ddc-block-reason, .ddc-refresh-warning { font-size: 12px; color: #b5673d; line-height: 1.7; overflow-wrap: anywhere; }
.ddc-note { color: #87909d; font-size: 12px; line-height: 1.8; margin-bottom: 0; }
@media (max-width: 560px) {
  .doudian-distribution-check .el-dialog__body { padding: 10px 14px 16px; }
  .doudian-distribution-check .el-dialog__footer { display: flex; flex-wrap: wrap; justify-content: flex-end; gap: 8px; }
  .doudian-distribution-check .el-dialog__footer .el-button + .el-button { margin-left: 0; }
}
</style>
